import { useCallback, useEffect, useState } from 'react'
import { TaskSummaryService } from '@/api/generated/services/TaskSummaryService'
import type { TaskSummaryStrategyResponse } from '@/api/generated/models/TaskSummaryStrategyResponse'
import { extractErrorMessage } from '@/utils/api-error-handler'
import { getSchoolYearRange } from '../strategyMetrics'

/** 전략과제 현황 데이터 (학년도 기준) */
export function useStrategySummary(
  workspaceId: string | undefined,
  schoolYear: number
) {
  const [data, setData] = useState<TaskSummaryStrategyResponse | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchData = useCallback(async () => {
    if (!workspaceId) return

    setLoading(true)
    setError(null)
    try {
      const { startDate, endDate } = getSchoolYearRange(schoolYear)
      const response =
        await TaskSummaryService.appsTaskViewsGetTaskSummaryStrategy({
          workspaceId,
          startDate,
          endDate,
        })
      setData(response)
    } catch (err) {
      console.error('Failed to fetch strategy summary:', err)
      setError(
        `누적 현황을 불러오지 못했습니다: ${extractErrorMessage(err)}`
      )
    } finally {
      setLoading(false)
    }
  }, [workspaceId, schoolYear])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return { data, loading, error, refetch: fetchData }
}
